module.exports = __webpack_public_path__ + "static/media/target.e7a8241e.png";